import { OptionalFeature } from "../../../../base/domain/drawing";
import { IEmptyAlertBehavior } from "./IEmptyAlertBehavior";

export class EmptyAlertBehavior extends OptionalFeature {
  constructor(
    isEnable: boolean     = false,
  ) {
    super(isEnable);
  }

  clone(): EmptyAlertBehavior {
    return new EmptyAlertBehavior(this.isEnable);
  }

  static from(source: IEmptyAlertBehavior): EmptyAlertBehavior {
    return new EmptyAlertBehavior(source.isEnable);
  }

  static to(source: EmptyAlertBehavior): IEmptyAlertBehavior {
    return {
      isEnable: source.isEnable,
    };
  }
}
